(() => {
  function toggleAddToCartNew() {
    const deliverySpan = document.querySelector('.cs_delivery_wrapper-value');
    const stickyWrapper = document.querySelector('[js-pdp-sticky-addtocart-wrapper]');
    const hasContentNew = deliverySpan && deliverySpan.textContent.trim() !== '';
    
    if (deliverySpan && stickyWrapper) {
      stickyWrapper.classList.toggle('disabled-button', !hasContentNew);
    }
    return hasContentNew;
  }
  // Immediately disable on load
  toggleAddToCartNew();
  // Poll every 300ms until text appears (max 15s)
  let attempts = 0;
  const poll = setInterval(() => {
    attempts++;
    if (toggleAddToCartNew() || attempts >= 100) {
      clearInterval(poll);
    }
  }, 300);
})();
document.addEventListener('DOMContentLoaded', function() {
  const selectors = {
      templateSelector        : '[js-product-template]',
      popupModalBtn           : '[js-pdp-open-modal]',
      popupModal              : '[js-popup-modal]',
      closeModalBtn           : '[js-popup-close-btn]',
      sizeChartPopupSelector  : '[js-pdp-size-chart-popup]',
      saveModalBtnSelector    : '[js-popup-save-btn]',     

      variantSelectSelector   : '[js-custom-variant-selects]',
      stitchedGroupSelector   : '[js-stitched-group]',
      customPropertySelector  : '[js-custom-property-list]',
      requiredFieldsSelector  : '[js-required-property-field]',
    
      stictchedPropertyDropSelector : '[js-option-drop-1] select',

      optionValuesSelector    : '[js-size-options]',
      stitchedOptionSelector  : '[js-stiched-option-name]',

      confSizeOptionSelector : '[js-conf-size-option-name]',
      confSizeOptionWrapperSelector :'[js-made-to-order-outfit-wrapper]',

      errorWrapperSelector    : '[js-pdp-form-error]',
      modalErrorList          : '[js-error-list]',

      customMeasurementMethodSelector : '[js-pdp-measurement-method-options]',
      customMeasurementOptionSelector : '[js-pdp-custom-measurement-option]',
      customMeasurementDetailSelector : '[js-pdp-select-detail-btn]',

      popupOverlay                    :'.product-custom .popup-overlay',

      copyToClipBoard                 : '[js-copy-to-clipboard]'
    }
    const templateContainer = document.querySelector(selectors.templateSelector)
    const customMeasurementMethodsContainer = templateContainer.querySelector(selectors.customMeasurementMethodSelector) 
    const confSizeOptionWrapper             = templateContainer.querySelector(selectors.confSizeOptionWrapperSelector)
    // variant select options
    const variantSelects    = templateContainer.querySelector(`${selectors.stitchedOptionSelector}`)
    const confSizeOption    = templateContainer.querySelector(`${selectors.confSizeOptionSelector}`)
    const templateName      = templateContainer?.dataset.productTemplateName


    const copyLinkWrapper   = templateContainer.querySelector(selectors.copyToClipBoard)

    // product stitched property drops
    const stictchedPropertyDrops = templateContainer.querySelectorAll(selectors.stictchedPropertyDropSelector)
    if(stictchedPropertyDrops.length) {
      stictchedPropertyDrops.forEach(el_ => {
        el_.addEventListener('change', productPropertyDropHandler)
      })
    }
    

    // all required fields of template
    const allRequiredFields = templateContainer.querySelectorAll(selectors.requiredFieldsSelector)
    // variant options
    const optionValues = templateContainer.querySelectorAll(`${selectors.stitchedGroupSelector}${selectors.optionValuesSelector} label`)

    // to remove required fields in case we don't need on fresh load
    const initialSelectedCheckField = templateContainer.querySelector(`${selectors.variantSelectSelector} input:checked`)
    const initialSelectedOption = initialSelectedCheckField?.value
    if(initialSelectedOption && optionValues.length) {
      if(initialSelectedOption && (initialSelectedOption == 'Unstitched' || initialSelectedOption == 'Made to Order')) {
        // remove all required fields of stitched group
        requiredFieldsToggle(allRequiredFields, true)
        if(initialSelectedCheckField && initialSelectedCheckField.name == 'Size Options' && initialSelectedOption == 'Made to Order' && confSizeOptionWrapper) {
          confSizeOptionWrapper.classList.remove('hide')
        }
        optionValues[0].click()

        // stitch return note
        ToggleUpsellReturnNote(templateContainer)
        templateContainer.querySelectorAll('input[name="items[0][properties[Custom blouse option]]"]').forEach(elm => {
          elm.removeAttribute('required');
        })

      } else {
        // optionValues[1].click()
        // stitch return note
        ToggleReturnNote(templateContainer)
      }
    }

    // All events
    templateContainer.addEventListener('click', handlePopupModals)
    variantSelects?.addEventListener('change', handleOptionChange)
    confSizeOption?.addEventListener('change', handleOptionChange)
    customMeasurementMethodsContainer?.addEventListener('click', handleCustomMeasurement)
    document.addEventListener('custom-measurement:reset', resetCustomMeasurements)
    copyLinkWrapper?.addEventListener('click', copyClipBoard)

    function copyClipBoard(e) {
      const wrapper_ = e.target.closest(selectors.copyToClipBoard)
      const productLink = wrapper_?.dataset.productLink
      const popup_  = e.target.closest('[js-product-share-popup]')

      if(productLink) {
        navigator.clipboard.writeText(productLink)
        .then(() => {
          console.log({popup_})
          popup_.querySelector('[js-link-copy-success]').style.opacity = 1;
          setTimeout(() => {
            popup_.querySelector('[js-link-copy-success]').style.opacity = 0;
          },2000)
        })
      }
    }
    function resetCustomMeasurements({detail}) {
    
      if(detail) {
        const { title } = detail
        const selectedOptionTitle   = title.split('/')[1]?.trim()
  
        if(selectedOptionTitle != 'Custom Size') {
          clearWhatsAppEntries()
          clearAfterOrderEntries()
          clearCustomMeasurementEntries()
        }
      }
    }
    function handlePopupModals(e) {
        const sizeChartPopupModal = templateContainer.querySelector(selectors.sizeChartPopupSelector)
        const self = e.target
        if(self.closest(selectors.popupModalBtn)) {
         
            const modalName = self.closest(selectors.popupModalBtn).dataset.modal || self.querySelector(selectors.popupModalBtn).dataset.modal
            templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`).classList.remove('hide')
            templateContainer.querySelector(selectors.popupOverlay).classList.remove('hide')

             if(document.body) {
               document.body.classList.add('popup-open');
             }
          
        } else if(self.closest(selectors.closeModalBtn)) {
            const modalName = self.closest(selectors.closeModalBtn)?.dataset.modal || self.querySelector(selectors.closeModalBtn)?.dataset.modal

            if(modalName != "select-measurement") {
             if(document.body) {
               document.body.classList.remove('popup-open');
             }
            }
          
            if(modalName == 'blouse-style') {
              templateContainer.querySelector('[js-blouse-style-popup] [js-popup-save-btn]')?.click()
              // const modalInputField_ = templateContainer.querySelector(`${selectors.popupModal} input:checked`)
              // if(modalInputField_) {
              //   modalInputField_.checked = false
              // }
              // templateContainer.querySelector(`${selectors.popupModalBtn}[data-modal='${modalName}'] span`).firstChild.textContent = 'Please Select'
            } else if(modalName == 'whatsapp-measurement') {
              const whatsappModal = templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`)
              const radio_ = whatsappModal.querySelector('input[type="radio"]:checked')
              const text_ = whatsappModal.querySelector('input[type="number"]')
              if(radio_) {
                radio_.checked = false
              }
              if(text_) {
                text_.value=''
              }
              if(initialSelectedOption && optionValues.length) {
                // optionValues[1].click()
              }
            } else if(modalName == 'custom-measurement' || modalName == 'choose_measurement') {
              if(initialSelectedOption && optionValues.length) {
                optionValues[1].click()
              }
            
            }
            

            templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`)?.classList.add('hide')
            if(modalName != "select-measurement") {
              templateContainer.querySelector(selectors.popupOverlay).classList.add('hide')
            }

        } else if(self.hasAttribute('js-size-convert-btn-inch')) {
            const wrapper = self.closest('[js-pdp-size-chart-popup]');
            self.classList.add('active')
            wrapper.querySelector('[js-size-convert-btn-cm]').classList.remove('active')
            convertInchCm('in', self)

        } else if(self.hasAttribute('js-size-convert-btn-cm')) {
            const wrapper = self.closest('[js-pdp-size-chart-popup]');
            self.classList.add('active')
            wrapper.querySelector('[js-size-convert-btn-inch]').classList.remove('active')
            convertInchCm('cm', self)
        } else if(self.closest(selectors.saveModalBtnSelector)) {
          const modalName = self.closest(selectors.saveModalBtnSelector)?.dataset.modal || self.querySelector(selectors.saveModalBtnSelector)?.dataset.modal
          
          if(modalName == 'blouse-style') {
            const modalInputField_ = templateContainer.querySelector(`${selectors.popupModal} input:checked`)
            const blouseStyleModal = templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`)
            const blouseStyleRequredInput = templateContainer.querySelector('#blouse-style-input')
            
            if (modalInputField_){
              templateContainer.querySelector(`${selectors.popupModalBtn}[data-modal='${modalName}'] span`).firstChild.textContent = modalInputField_.value
              blouseStyleRequredInput.value = modalInputField_.value
              blouseStyleModal.querySelector(selectors.modalErrorList).innerHTML = ''
              templateContainer.querySelector(selectors.popupOverlay).classList.add('hide')
              templateContainer.querySelector(`[js-popup-modal][data-popup-modal="${modalName}"]`).classList.remove('hide')
              document.body.classList.remove('popup-open');
            } else {
              blouseStyleModal.querySelector(selectors.modalErrorList).innerHTML = 'Please select any value'
              return
            }
           // templateContainer.querySelector(`[js-alternate-custom-pdp] ${selectors.popupOverlay}`).classList.add('hide')
            
          } else if(modalName == 'whatsapp-measurement') {
            const whatsappModal = templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`)
            const radio_ = whatsappModal.querySelector('input[type="radio"]:checked')
            const text_ = whatsappModal.querySelector('input[type="number"]')
            if(text_ && radio_) {
              whatsappModal.querySelector(selectors.modalErrorList).innerHTML = ''
            } else {
              whatsappModal.querySelector(selectors.modalErrorList).innerHTML = 'Please select any value'
              return
            }

            templateContainer.querySelector(selectors.popupOverlay).classList.remove('hide')
            templateContainer.querySelector('[js-pdp-whatsapp-complete-modal]')?.classList.remove('hide')

          }
          templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal=${modalName}]`)?.classList.add('hide');
          templateContainer.querySelector(selectors.popupOverlay).classList.add('hide')


        } else if(self.closest(selectors.popupOverlay)) {

           if(document.body) {
               document.body.classList.remove('popup-open');
          }
          
          const allPopups = templateContainer.querySelectorAll('[js-popup-modal][data-popup-modal]')
          let openedPopups = []
          allPopups.forEach(popup => {
            if(!popup.classList.contains('hide') && !popup.getAttribute('data-popup-option-name')) {
              openedPopups.push(popup)
            }
          })
          // console.log(openedPopups)
          openedPopups.forEach(popup => {
            const modalName = popup.dataset.popupModal
            if( modalName == 'whatsapp-measurement' || modalName == 'complete-measurement' || modalName == 'choose-measurement') {
              if(initialSelectedOption && optionValues.length) {
                optionValues[1].click()
              }
            }
            // console.log(modalName)
            if(modalName == 'blouse-style') {
              templateContainer.querySelector('[js-blouse-style-popup] [js-popup-save-btn]')?.click()
              // const modalInputField_ = templateContainer.querySelector(`${selectors.popupModal} input:checked`)
              // if(modalInputField_) {
              //   modalInputField_.checked = false
              // }
              // templateContainer.querySelector(`${selectors.popupModalBtn}[data-modal='${modalName}'] span`).firstChild.textContent = 'Please Select'
            }
            popup.classList.add('hide')
          })

          self.closest(selectors.popupOverlay).classList.add('hide')
        } 
        if(self.hasAttribute('js-mini-size-convert-btn-inch')) {
            self.classList.add('active')
            document.querySelector('[js-mini-size-convert-btn-cm]').classList.remove('active')
            convertInchCm('in', self)
          
          } 
        if (self.hasAttribute('js-mini-size-convert-btn-cm')) {

            self.classList.add('active')
            document.querySelector('[js-mini-size-convert-btn-inch]').classList.remove('active')
            convertInchCm('cm', self)
        }
    }
    
    function handleOptionChange(e) {
    
      const checkedOption = e.target.value
      const customPropertyContainer = templateContainer.querySelector(`${selectors.customPropertySelector}`)
    
      if(checkedOption == 'Unstitched' || checkedOption == 'Made to Order' ) {
        // remove all elements related to stitched
        templateContainer.querySelectorAll(selectors.stitchedGroupSelector).forEach(elm => {
          elm.classList.add('hide')
        })
        if (templateContainer.querySelector('#blouse-style-input')) {
          templateContainer.querySelector('#blouse-style-input').removeAttribute('required');
        }

        // select first option
        if(initialSelectedOption && optionValues.length) {
          optionValues[0].click()
        }
        // remove all required fields of stitched group
        requiredFieldsToggle(allRequiredFields, true)

        // clear option select fields
        unselectOptionDrops(templateContainer, customPropertyContainer)

        //clear error wrapper too
        const erorWrapper = templateContainer.querySelector(`${selectors.errorWrapperSelector} ul`)
        removeErrorFields(erorWrapper)
        if(!erorWrapper.childNodes.length) {
          erorWrapper.style.display = "none"
        }
        
        //clear custom measurements
        const customMeasurementFields = templateContainer.querySelectorAll('[js-pdp-select-measurement-popup] input:checked')
        if(customMeasurementFields.length) {
          clearAllRadioFields(customMeasurementFields)
        }

        // clear ui from select-measurement popup
        const selectMeasurementFields = templateContainer.querySelectorAll('[js-pdp-select-detail-btn] .select-text')
        if(selectMeasurementFields.length) {
          selectMeasurementFields.forEach(el => {
            el.textContent = 'Select'
          })
        }
        const selectMeasurementImageFields = templateContainer.querySelectorAll('[js-pdp-select-detail-btn] img')
        if(selectMeasurementImageFields.length) {
          selectMeasurementImageFields.forEach(el => el.remove())
        }

        // clear custom whatsapp modal fields
        const whatsappModal = templateContainer.querySelector('[js-pdp-whatsapp-measurement-popup]')
        const radio_ = whatsappModal?.querySelector('input[type="radio"]:checked')
        const text_ = whatsappModal?.querySelector('input[type="number"]')
        if(radio_) {
          radio_.checked = false
        }
        if(text_) {
          text_.value=''
        }

        //  clear measure after order
        const afterOrderModal = templateContainer.querySelector('[js-pdp-custom-measurement-complete-modal]')
        if(afterOrderModal && afterOrderModal.querySelector('input:checked')) {
          afterOrderModal.querySelector('input:checked').checked = false
        }

        // cusf outfit wrapper 
        if(confSizeOptionWrapper) {
          confSizeOptionWrapper.classList.remove('hide')
        }
        

        // hide
        ToggleUpsellReturnNote(templateContainer)

        //Remove class on non returnable product
        if (checkedOption != 'Standard Size') {
          document.querySelector('[js-product-details]').classList.remove('non-returnable')
          const returnablePropertieInput = this.form.querySelector("#returnable-propertie-input");
          returnablePropertieInput.value = "True"
        }
        const customOptionInput = this.form.querySelector('#selected-custom-option');
        customOptionInput.setAttribute('disabled', '');

        const customSelectOptions = this.form.querySelector('.custom-select-options-wrap')
        const customSelectOptionInput = this.form.querySelector('input[name="items[0][properties[Custom blouse option]]"]')
        const customSelectOptionInputRadio = this.form.querySelector('.blouse-style-radio:checked')
        if (customSelectOptions) {
          customSelectOptions.classList.add('hidden')
          customSelectOptionInput.value = ''
          this.form.querySelector('.selected-style-text').textContent = 'Select Style';
          if (customSelectOptionInputRadio) {
            customSelectOptionInputRadio.checked = false
          }
        }
        this.form.querySelectorAll('input[name="items[0][properties[Custom blouse option]]"]').forEach(elm => {
          elm.removeAttribute('required');
        })
        
      } else {

        // show all elements related to stitched
        templateContainer.querySelectorAll(selectors.stitchedGroupSelector).forEach(elm => {
          elm.classList.remove('hide')
        })
        if (templateContainer.querySelector('#blouse-style-input')) {
          templateContainer.querySelector('#blouse-style-input').setAttribute('required', 'true');
        }

        // set all required fields of stitched group
        requiredFieldsToggle(allRequiredFields, false)

        // select first option
        // optionValues[1].click()

        if(confSizeOptionWrapper) {
          confSizeOptionWrapper.classList.add('hide')
        }

        // return  note
        ToggleReturnNote(templateContainer)

        //Add class on non returnable product
        if (checkedOption != 'Standard Size') {
          document.querySelector('[js-product-details]').classList.add('non-returnable')
          const returnablePropertieInput = this.form.querySelector("#returnable-propertie-input");
          if (returnablePropertieInput) returnablePropertieInput.value = "False"
        }
        
        templateContainer.querySelectorAll('.o-Size .product-form__input_wrap input[type=radio]').forEach(elm => {
          elm.removeAttribute('disabled');
        })

        const customSelectOptions = this.form.querySelector('.custom-select-options-wrap')
        if (customSelectOptions) {
          customSelectOptions.classList.remove('hidden')
        }
        this.form.querySelectorAll('input[name="items[0][properties[Custom blouse option]]"]').forEach(elm => {
          elm.setAttribute('required', 'true');
        })
        const unstitchedSelected = document.querySelector('.product_details:has(input[type="hidden"][value="Saree"]) .product-form__input input[type=radio][value="Fabric Only"]')
        if (unstitchedSelected) {
          unstitchedSelected.checked = false;
        }
        
      }
    }
    function handleCustomMeasurement(e) {
      const self = e.target
      if(self.closest(selectors.customMeasurementOptionSelector) || self.getAttribute(selectors.customMeasurementOptionSelector)) {
        const selectedOption = self.getAttribute(selectors.customMeasurementOptionSelector) ?  self : self.closest(selectors.customMeasurementOptionSelector);

        const modalName = selectedOption.dataset.optionName
        const popupModal = templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`)
        
        if(popupModal) {
          popupModal.classList.remove('hide')
          templateContainer.querySelector(selectors.popupOverlay).classList.remove('hide')
        }

        if(modalName == 'whatsapp-measurement') {
          let selectBox = templateContainer.querySelector(`${selectors.popupModal}[data-popup-modal="${modalName}"]`).querySelector('[js-pdp-select-measurement-popup]').querySelector('select#country_code');
          if(selectBox) {
            selectBox.setAttribute('name', 'items[0][properties][Country Code]');
            selectBox.removeAttribute("disabled");
          }
          clearCustomMeasurementEntries()
          clearAfterOrderEntries()
        } else if(modalName == 'custom-measurement' || modalName == 'choose_measurement') {
          clearWhatsAppEntries()
          clearAfterOrderEntries()

        } else if(modalName == 'complete-measurement') {
          clearWhatsAppEntries()
          clearCustomMeasurementEntries()

        }
        // hide main popup
        customMeasurementMethodsContainer.classList.add('hide')
      }
    }

    function productPropertyDropHandler(e) {
      const self = e.target
      document.dispatchEvent(new CustomEvent('nativePropertySelectOptionDrop:init', { detail: self}))
    }

    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var selectedLabel = document.querySelector('label[for="' + input.id + '"]');
      var variantQuantity = selectedLabel.getAttribute('data-variant-quantity');
      var bisFormWrapper = document.getElementById('appikon-bis-inline-form-wrapper');
      if (bisFormWrapper) {
        if (variantQuantity == '0') {
          bisFormWrapper.classList.remove('hidden')
        } else {
          bisFormWrapper.classList.add('hidden')
        }
      }
      if (selectedLabel) {
        var extraContent = selectedLabel.querySelector('.extra-size-content-text');
        var outputElement = document.querySelector('.additional_size_massage_text');
        if (extraContent) {
          outputElement.innerHTML = extraContent.innerHTML;
          outputElement.classList.remove('hidden');
        } else {
          outputElement.innerHTML = '';
          outputElement.classList.add('hidden');
        }
      }
    });
  });

  const container_ = document.querySelector('[js-product-details]')
  const preDrapeSelect = container_.querySelectorAll('.options-dropdown-list-pre-drap select')
  if (preDrapeSelect) {
    preDrapeSelect.forEach(selectBox => {
      selectBox.selectedIndex = 0;
      selectBox.removeAttribute('required');
    })
  }
})

document.addEventListener('DOMContentLoaded', function() {
  const container_ = document.querySelector('[js-product-details]')

  const upsellProducts_ = container_.querySelectorAll('upsell-product input')

  upsellProducts_.forEach(upsellProd => {
    upsellProd.addEventListener('change', function(e) {
      const stitchedSelectedCheckField = container_.querySelector('[js-custom-variant-selects] input[value="Stitched"]:checked')
      document.addEventListener('sumTotalPrice:run', sumTotalPrice)
      document.dispatchEvent(new CustomEvent('sumTotalPrice:run'))

      function sumTotalPrice() {
        const mainProductPrice = container_.querySelector('[data-pdp-product-price]').dataset.pdpProductPrice
        const stickyATCPrice = document.querySelectorAll('[js-pdp-sticky-addtocart-wrapper] form [js-pdp-original-price]')

        const allCheckedUpsellProducts = container_.querySelectorAll('upsell-product input:checked')
        const preDrapeChecked = container_.querySelectorAll('upsell-product input[value="pre_drape"]:checked')
        const preDrapeSelect = container_.querySelectorAll('.options-dropdown-list-pre-drap select')
        const returnablePropertieInput = container_.querySelector("#returnable-propertie-input");
          
        let totalUpsellProductPrice = 0
        if(allCheckedUpsellProducts.length) {
          allCheckedUpsellProducts.forEach(upsellItem => {
            const parent_ = upsellItem.closest('upsell-product')
            const price = parent_.dataset.upsellProductPrice
            totalUpsellProductPrice += parseFloat(price.replace(/,/g, ''));
          })
            //Add class on non returnable product
            document.querySelector('[js-product-details]').classList.add('non-returnable-pre-drap')
            if (returnablePropertieInput) returnablePropertieInput.value = "False"
            if (preDrapeChecked.length && preDrapeSelect) {
              preDrapeSelect.forEach(selectBox => {
                if (selectBox.hasAttribute("js-required-property-field")) {
                  selectBox.setAttribute('required', 'true');
                }
              })
            }
          } else {
            //Remove class on non returnable product
            document.querySelector('[js-product-details]').classList.remove('non-returnable-pre-drap')
            returnablePropertieInput.value = "True"
            if (preDrapeChecked && preDrapeSelect) {
              preDrapeSelect.forEach(selectBox => {
                selectBox.selectedIndex = 0;
                selectBox.removeAttribute('required');
              })
            }
          }
          if (stitchedSelectedCheckField) {
            if (returnablePropertieInput) returnablePropertieInput.value = "False"
          }
          const currencySymbol = container_.querySelector('[data-shop-currency]').dataset.shopCurrency
          const ctaBtn = container_.querySelector('form button[type="submit"] [js-pdp-original-price]')
          let mainProductPriceChange = parseFloat(mainProductPrice.replace(/,/g, ''));
          const sum = mainProductPriceChange + totalUpsellProductPrice;
          const displayTotalPrice = `${currencySymbol} ${sum}`
  
          ctaBtn.textContent = displayTotalPrice;
          if(stickyATCPrice) {
            stickyATCPrice.forEach(item => {
              item.textContent = displayTotalPrice
            });
          }
      }
    })
  })  

    function changeStickyBtnText() {
    let primaryAtcButton= document.querySelector('.product-form__submit')
    let atcButtonContent= primaryAtcButton.querySelector('span').innerHTML

    
    const stickyBtn = document.querySelector('[js-pdp-stick-addtocart-btn]')
    let targetButton = stickyBtn.querySelector('[js-sticky-atc-btn-text]')
    
    if(primaryAtcButton.classList.contains('unavailable-variant')) {
      stickyBtn.classList.add('unavailable-variant')
    } else {
      stickyBtn.classList.contains('unavailable-variant') && stickyBtn.classList.remove('unavailable-variant')
    }
    targetButton.innerHTML= atcButtonContent
  }


  document.addEventListener('changeStickyBtnText:run', changeStickyBtnText)
  document.dispatchEvent(new CustomEvent('changeStickyBtnText:run'))
})

document.addEventListener('DOMContentLoaded', () => {
  const discountInput = document.getElementById('discount-on-product');
  const comparePriceInput = document.getElementById('compare-at-price');

  // Function to update hidden fields when radio changes
  function updateProductDetails(radio) {
    const comparePrice = radio.getAttribute('data-product-compare-price');
    const discount = radio.getAttribute('data-product-discount');

    if (comparePrice) {
      comparePriceInput.value = comparePrice;
    } else {
      comparePriceInput.value = ''; // Clear value if compare price is empty
    }

    if (discount) {
      discountInput.value = discount;
    } else {
      discountInput.value = ''; // Clear value if discount is empty
    }
  }

  if (discountInput && comparePriceInput) {
    const sizeRadios = document.querySelectorAll('.product-form input[type="radio"]');
    sizeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        updateProductDetails(this); // Update on radio selection
      });
  
      // Check if a radio is pre-selected (on page load)
      if (radio.checked) {
        updateProductDetails(radio);
      }
    });
  }
});

function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod|android|blackberry|windows phone/i.test(userAgent);
}
if (isMobileDevice()) {
  let clickedLabel = false;
  const labels = document.querySelectorAll('.product-form__input_wrap label');
  labels.forEach(label => {
    label.addEventListener('click', function (e) {
      e.stopPropagation();
      clickedLabel = true;
      const tooltip = label.querySelector('.size-detail-wrap');
      if (!tooltip) return;
      document.querySelectorAll('.size-detail-wrap').forEach(t => {
        t.style.visibility = 'hidden';
        t.style.opacity = '0';
      });
      tooltip.style.visibility = 'visible';
      tooltip.style.opacity = '1';
    });
  });
  document.addEventListener('click', function () {
    setTimeout(() => {
      if (clickedLabel) {
        clickedLabel = false;
        return;
      }
      document.querySelectorAll('.size-detail-wrap').forEach(t => {
        t.style.visibility = 'hidden';
        t.style.opacity = '0';
      });
    }, 0);
  });
}



// Show one day delivery
let userCity = '';
const resultDiv = document.getElementById("locationResult");
const jsDeliveryWrapper= document.querySelectorAll('.cs_delivery_wrapper')
const additionalDeliveryMassageText= document.querySelectorAll('.additional_delivery_massage_text')
const locationResult= document.querySelectorAll('#locationResult')
const zipCodeInput= document.querySelectorAll('.zip-code-input')
const deliveredTodayNote= document.querySelectorAll('.delivered-today-note')
const delivereToday= document.querySelectorAll('#delivereToday')

function removeSameDayDelivery(form) {
  
  deliveredTodayNote.forEach((e) => {e.classList.add("hidden");})
  delivereToday.forEach((e) => {e.setAttribute('disabled', '');e.removeAttribute('name');})
  additionalDeliveryMassageText.forEach((e) => {e.classList.remove("hidden");})
  zipCodeInput.forEach((e) => {e.classList.add("hidden");})
  locationResult.forEach((e) => {e.classList.add("hidden");})
  jsDeliveryWrapper.forEach((e) => {e.classList.remove("hidden");})
}

// function getLocationDetails() {
  
//   const pincode = document.getElementById("pincodeInput").value.trim();
//   const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
//   const zipList = window.zipCodeList || [];
//   const isPincodeAvailable = zipList.includes(pincode);
//   const selectedZipText = document.querySelector('.selected-zip span');
  
//   if (!pincode || pincode.length !== 6) {
//     resultDiv.classList.remove('hidden')
//     resultDiv.textContent = "Valid 6-digit PIN required";
//   }
//   // resultDiv.classList.add('hidden')
  
//   if (window.innerWidth < 750 && isPincodeAvailable) {
//     localStorage.setItem('global_user_pincode', pincode);
//   }
  
//   productForms.forEach((form) => {
//     fetch(`https://api.postalpincode.in/pincode/${pincode}`)
//       .then(response => response.json())
//       .then(data => {
//         if (data[0].Status === "Success") {
//           // console.log('Success Valid 6-digit')
//           const postOffice = data[0].PostOffice[0];
//           userCity = postOffice.District;
//           oneDayDelivery(userCity);
//           // console.log('userCity', userCity);
//           if (window.innerWidth < 750) {
//             localStorage.setItem('global_user_pincode', pincode);
//             localStorage.setItem('plp_selected_address_city', userCity);
//             if (selectedZipText) {
//               selectedZipText.textContent = pincode;
//             }
//           }
//           closeZipPopup()
//           if (isPincodeAvailable) {
//             oneDayDelivery(userCity);
//             // console.log('userCity if',userCity);
//           } else {
//             // console.log('userCity else');
//             removeSameDayDelivery(form);
//             const zipCodeWrap = form.querySelector('.zip-code-input');
//             zipCodeWrap.classList.remove('hidden');
//             locationResult.forEach((e) => {
//               e.classList.remove('hidden');
//               e.textContent = "Express delivery isn't available in your area.";
//             });
//           }
//         } else {
//           const storedPin = localStorage.getItem('plp_selected_pincode');
//           if (storedPin) return;
//           // console.log('Valid 6-digit')
//           locationResult.forEach((e) => {
//             e.textContent = "Valid 6-digit PIN required";
//           });
//           deliveredTodayNote.forEach((e) => {e.classList.add("hidden");})
//           delivereToday.forEach((e) => {e.setAttribute('disabled', '');e.removeAttribute('name');})
//           jsDeliveryWrapper.forEach((e) => {e.classList.remove("hidden");})
//           additionalDeliveryMassageText.forEach((e) => {e.classList.remove("hidden");})
//         }
//       })
//       .catch(error => {
//         locationResult.forEach((e) => {
//           e.textContent = "Error fetching location. Please try again.";
//         });
//         console.error(error);
//       });
//   });
// }
function getLocationDetails() {
  
  const pincode = document.getElementById("pincodeInput").value.trim();
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  const zipList = window.zipCodeList || [];
  const isPincodeAvailable = zipList.includes(pincode);
  const selectedZipText = document.querySelector('.selected-zip span');
  
  if (!pincode || pincode.length !== 6) {
    resultDiv.classList.remove('hidden')
    resultDiv.textContent = "Valid 6-digit PIN required";
  }

  // page load par pin save nahi karo — sirf display karo
  
  productForms.forEach((form) => {
    fetch(`https://api.postalpincode.in/pincode/${pincode}`)
      .then(response => response.json())
      .then(data => {
        if (data[0].Status === "Success") {
          const postOffice = data[0].PostOffice[0];
          userCity = postOffice.District;

          // ✅ FIX 2: yahan bhi innerWidth condition hata do — ALWAYS save karo
          localStorage.setItem('plp_selected_address_city', userCity);
          if (selectedZipText) {
            selectedZipText.textContent = pincode;
          }

          closeZipPopup()
          oneDayDelivery(userCity);

          if (!isPincodeAvailable) {
            removeSameDayDelivery(form);
            const zipCodeWrap = form.querySelector('.zip-code-input');
            zipCodeWrap.classList.remove('hidden');
            locationResult.forEach((e) => {
              e.classList.remove('hidden');
              e.textContent = "Express delivery isn't available in your area.";
            });
          }
        } else {
          const storedPin = localStorage.getItem('plp_selected_pincode');
          if (storedPin) return;
          locationResult.forEach((e) => {
            e.textContent = "Valid 6-digit PIN required";
          });
          deliveredTodayNote.forEach((e) => {e.classList.add("hidden");})
          delivereToday.forEach((e) => {e.setAttribute('disabled', '');e.removeAttribute('name');})
          jsDeliveryWrapper.forEach((e) => {e.classList.remove("hidden");})
          additionalDeliveryMassageText.forEach((e) => {e.classList.remove("hidden");})
        }
      })
      .catch(error => {
        locationResult.forEach((e) => {
          e.textContent = "Error fetching location. Please try again.";
        });
        console.error(error);
      });
  });
}

async function oneDayDelivery(userCity) {
  //if (!userCity) return;
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  const upsellProducts = document.querySelectorAll('product-form upsell-product input');
  productForms.forEach((form) => {
    form.querySelectorAll('input[type=radio]').forEach(input => input.classList.remove('available-in-user-city'));
    form.querySelectorAll('label').forEach(label => label.classList.remove('available-in-user-city'));
    const zipCodeWrap = form.querySelector('.zip-code-input');
    const jsDeliveryWrapper= document.querySelectorAll('.cs_delivery_wrapper');

    // const storedPin = localStorage.getItem('plp_selected_pincode');
    const storedPin = localStorage.getItem('global_user_pincode');
    const storedPinCity = localStorage.getItem('plp_selected_address_city');
    const pincode = document.getElementById("pincodeInput")

    const firstAvailableInput = window.firstAvailableInput;
    let firstInput = ''
    let firstInputLabel = ''
    if (firstAvailableInput) {
      firstInput = form.querySelector(`input[type="radio"][value="${firstAvailableInput}"], option[value="${firstAvailableInput}"]`);
      firstInputLabel = form.querySelector(`label[for="${firstInput.id}"]`);
    }
    const simpleProductLocations = form.querySelector('.simple-product-locations');

    // Get checked variant
    let checkedInput = form.querySelector('input[type=radio]:checked');
    let variantQuantity = ''
    let checkedLabel = '';
    const unstitchedSizeLabel = form.querySelector('.product-custom .product-form .product-form__input--pill input[value="Fabric Only"]+label');

    if (simpleProductLocations) {
      checkedLabel = simpleProductLocations;
      if (window.innerWidth < 750) {
        if (storedPin) {
          userCity = storedPinCity
          pincode.value = storedPin
        }
      }
      variantQuantity = Number(simpleProductLocations.dataset.variantQuantity);
    }
    if (!simpleProductLocations) {
      if (checkedInput) {
        // console.log('checkedInput', checkedInput)
        checkedLabel = form.querySelector(`label[for="${checkedInput.id}"]`);
        if (!checkedLabel) return;
        if (unstitchedSizeLabel && storedPin) {
          pincode.value = storedPin
        }
        variantQuantity = Number(checkedLabel.dataset.variantQuantity);
      } else if (storedPin) {
        // console.log('storedPin', storedPin)
        userCity = storedPinCity
        pincode.value = storedPin
        let checkedInputNew = document.querySelector('form[data-type="add-to-cart-form"] input[type=radio]:checked');
        checkedInput = checkedInputNew || firstInput
        checkedLabel = document.querySelector(`form[data-type="add-to-cart-form"] label[for="${checkedInput.id}"]`);
        variantQuantity = Number(firstInputLabel.dataset.variantQuantity);
        // console.log('storedPin', variantQuantity, pincode.value, userCity, checkedInputNew, checkedLabel)
      }
      if (!checkedInput && !storedPin) return;
    }
    // Read store data if exists
    const locationMap = {
      69840437402: "Santacruz, Mumbai",
      69840830618: "Ahmedabad",
      106251911531: "Delhi", // "Delhi Pitampura",
      69840961690: "Hyderabad",
      69840896154: "Surat",
      105350463851: "Mumbai Online Exclusives, Thane",
      // 105350463851: "Thane",
      109879034219: "KDH",
      69840863386: "Bangalore",
      69840732314: "Delhi", // "Delhi South Ext II",
      106251845995: "Indore",
      110510670187: "Ludhiana",
      109719716203: "Mumbai Kala Ghoda",
      110858928491: "Delhi" // "Delhi Warehouse"
    };
    let storeData = checkedLabel.dataset.storeLocations;
    let locations = [];
    if (storeData) {
      storeData = storeData.replace(/&quot;/g, '"');
      try {
        locations = JSON.parse(storeData);
      } catch (e) {
        console.error('Invalid JSON in data-store-locations:', storeData);
      }
    }

    locations = locations.map(loc => ({
      ...loc,
      name: locationMap[loc.location?.id] || "Unknown", // add a readable name
      available: loc.quantity > 0 // set availability based on quantity
    }));

    let isAvailable = locations.some(loc => {
      return loc.available === true
    });

    if (isAvailable && variantQuantity !== 0) {
      zipCodeWrap.classList.remove('hidden');
      locationResult.forEach((e) => {
        e.classList.remove('hidden');
      });
      if (form.querySelector('.additional_delivery_massage_text')){
        form.querySelector('.additional_delivery_massage_text').classList.add("hidden");
      }
      // console.log('isAvailable if');
    } else {
      // console.log('isAvailable else');
      removeSameDayDelivery(form);
    }

    let unstitchedLocations = [];
    const unstitchedSizeInput = form.querySelector('.product-custom .product-form .product-form__input--pill input[value="Fabric Only"]+label');
      if (unstitchedSizeInput) {
      let unstitchedUtoreData = unstitchedSizeInput.dataset.storeLocations;
      if (unstitchedUtoreData) {
        unstitchedUtoreData = unstitchedUtoreData.replace(/&quot;/g, '"');
        try {
          unstitchedLocations = JSON.parse(unstitchedUtoreData);
        } catch (e) {
          console.error('Invalid JSON in data-store-locations:', unstitchedUtoreData);
        }
      }
    }
    unstitchedLocations = unstitchedLocations.map(loc => ({
      ...loc,
      name: locationMap[loc.location?.id] || "Unknown", // add a readable name
      available: loc.quantity > 0 // set availability based on quantity
    }));
    // console.log('isAvailable 1',isAvailable);
    if (checkedInput && checkedInput.value === 'Unstitched' && !userCity) {
      isAvailable = true
      zipCodeWrap.classList.remove('hidden');
      locationResult.forEach((e) => {
        e.classList.remove('hidden');
      });
      document.querySelector('.additional_delivery_massage_text').classList.add("hidden");
      let upsellInputChecked = false;
      upsellProducts.forEach(upsellInput => {
        if (upsellInput.checked == true) {
          isAvailable = false
        }
      })
    }
    
    if (userCity) {
      let isAvailable = locations.some(loc => {
        // console.log('loc.name',loc.name, userCity, loc.available)
        // console.log('userCity isAvailable',loc.available === true, (loc.name.toLowerCase().includes(userCity.toLowerCase()) || userCity.toLowerCase().includes(loc.name.toLowerCase())) )
        return loc.available === true && (loc.name.toLowerCase().includes(userCity.toLowerCase()) || userCity.toLowerCase().includes(loc.name.toLowerCase()));
      });
      
      let unstitchedAvailable = unstitchedLocations.some(loc => {
        return loc.available === true && (loc.name.toLowerCase().includes(userCity.toLowerCase()) || userCity.toLowerCase().includes(loc.name.toLowerCase()));
      });
      // console.log('loc.available', isAvailable)
      
      
      if (unstitchedAvailable && checkedInput && checkedInput.value === 'Unstitched') {
        isAvailable = true
        zipCodeWrap.classList.remove('hidden');
        locationResult.forEach((e) => {
          e.classList.remove('hidden');
        });
        jsDeliveryWrapper.forEach((e) => {e.classList.add("hidden");})
        document.querySelector('.additional_delivery_massage_text').classList.add("hidden");
        let upsellInputChecked = false;
        upsellProducts.forEach(upsellInput => {
          if (upsellInput.checked == true) {
            isAvailable = false
          }
        })
      }
      
      if (isAvailable) {
        const now = new Date();
        const hour = now.getHours();
        const pincode = document.getElementById("pincodeInput").value.trim();
        document.querySelector('#delivereToday').value = `Yes, ${userCity}(${pincode})`
        locationResult.forEach((e) => {
          e.textContent = "";
        });
        if (hour < 15) {
          document.querySelector('.delivered-today-note').classList.remove("hidden");
          document.querySelector('.delivered-today-note div').innerHTML = `
            <b>${userCity} Express: Same-Day Delivery</b>
            <ul>
              <li>Prepaid Orders</li>
              <li>Order Before 3 PM</li>
              <li>Easy Returns</li>
            </ul>
          `;
          document.querySelector('#delivereToday').removeAttribute('disabled');
          document.querySelector('#delivereToday').setAttribute('name', 'items[0][properties[Delivere today]]');
        } else {
          document.querySelector('.delivered-today-note').classList.remove("hidden");
          document.querySelector('.delivered-today-note div').innerHTML = `
            <b>${userCity} Express: Next-Day Delivery</b>
            <ul class="next-day-list">
              <li>Prepaid Orders</li>
              <li>Easy Returns</li>
            </ul>
          `;
          document.querySelector('#delivereToday').removeAttribute('disabled');
          document.querySelector('#delivereToday').setAttribute('name', 'items[0][properties[Next day delivery]]');
        }
        additionalDeliveryMassageText.forEach((e) => {e.classList.add("hidden");})
        jsDeliveryWrapper.forEach((e) => {e.classList.add("hidden");})
        // console.log('isAvailable if 2');
      } else {
        // console.log('isAvailable else 2');
        removeSameDayDelivery(form);
        zipCodeWrap.classList.remove('hidden');
        locationResult.forEach((e) => {
          e.classList.remove('hidden');
          e.textContent = "Express delivery isn't available in your area.";
        });
      }
    }

    if (!isAvailable && checkedInput && checkedInput.value !== 'Unstitched') {
      removeSameDayDelivery(form);
    }

    if (variantQuantity === 0) {
      removeSameDayDelivery(form);
      setTimeout(() => {
        zipCodeInput.forEach((e) => {e.classList.add("hidden");})
        locationResult.forEach((e) => {e.classList.add("hidden");})
      }, 10);
    }
    
    // if (!checkedLabel.dataset.oneDayDelivery && checkedInput.value != 'Unstitched') {
    //   removeSameDayDelivery(form);
    // }
  });
}
 
document.addEventListener('DOMContentLoaded', () => {

  //pdp pincode 
    const btn = document.getElementById('checkPincodeBtn');
    if (btn) {
      btn.addEventListener('click', function (e) {
      e.preventDefault();
      const pin = document.getElementById('pincodeInput')?.value?.trim();
      if (pin && /^\d{6}$/.test(pin)) {
        savePin(pin, true); // ✅ Manual
      }
      getLocationDetails();
    });
    }

    // ✅ setTimeout — sabse last mein run hoga
    setTimeout(() => {
      const input = document.getElementById('pincodeInput');
      const selectedZipText = document.querySelector('.selected-zip span');

      // ✅ Ek hi jagah se pin lo
      const finalPin = (typeof getFinalPin === 'function') ? getFinalPin() : null;

      if (finalPin && /^\d{6}$/.test(finalPin)) {
        if (input) input.value = finalPin;
        if (selectedZipText) selectedZipText.textContent = finalPin;
        getLocationDetails();
      } else {
        // Blank state
        if (input) input.value = '';
        if (selectedZipText) selectedZipText.textContent = 'Pincode';
        const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
        productForms.forEach(form => {
          const zipCodeWrap = form.querySelector('.zip-code-input');
          if (zipCodeWrap) zipCodeWrap.classList.remove('hidden');
        });
      }
    }, 300);
    
  //pdp pincode 


  if (window.innerWidth < 750) {
    const wrap = document.querySelector('.zip-code-plp-wrap');
    if (!wrap) return;

    const popup = wrap.querySelector('.zip-code-input-popup');
    const selectedZip = wrap.querySelector('.selected-zip');
    const selectedZipText = selectedZip?.querySelector('span');
    const closeBtn = wrap.querySelector('#close-location');
    const pincodeInput = wrap.querySelector('#pincodeInput');
    const addressItems = wrap.querySelectorAll('li[data-custome-zip]');

    /* open popup */
    selectedZip?.addEventListener('click', () => {
      // console.log('click zip')
      popup.classList.add('active');
      document.documentElement.classList.add('location-popup-active');
    });

    /* close popup */
    closeBtn?.addEventListener('click', () => {
      popup.classList.remove('active');
      document.documentElement.classList.remove('location-popup-active');
    });

    /* saved address click */

    addressItems.forEach((li, index) => {
      li.dataset.addressKey ||= index;

      li.addEventListener('click', () => {
        const zip = li.dataset.customeZip;
        const addressKey = li.dataset.addressKey;

        if (!zip) return;

        // ✅ savePin() se sab keys sync hongi
        savePin(zip, true);
        localStorage.setItem('plp_selected_pincode', zip);
        localStorage.setItem('plp_selected_address_key', addressKey);

        /* UI */
        pincodeInput.value = zip;
        selectedZipText.textContent = zip;

        addressItems.forEach(i => i.classList.remove('active'));
        setTimeout(() => {
          li.classList.add('active');
        }, 10);

        popup.classList.remove('active');
        document.documentElement.classList.remove('location-popup-active');

        getLocationDetails();
      });
    });

    
    const storedPin = localStorage.getItem('plp_selected_pincode');
    const storedAddressKey = localStorage.getItem('plp_selected_address_key');

    if (storedPin) {
      pincodeInput.value = storedPin;
      selectedZipText.textContent = storedPin;

      addressItems.forEach((li, index) => {
        setTimeout(() => {
         li.classList.remove('active')
        }, 10);
        if (!li.dataset.addressKey) {
          li.dataset.addressKey = String(index);
        }

        const zip = li.dataset.customeZip;
        const key = li.dataset.addressKey;

        if (
          storedPin &&
          storedAddressKey &&
          zip === storedPin &&
          key === storedAddressKey
        ) {
          setTimeout(() => {
          li.classList.add('active');
          }, 10);
        }
      });
      getLocationDetails();
    } else {
      if (window.customerDefaultPincode && pincodeInput) {
        pincodeInput.value = window.customerDefaultPincode;
        selectedZipText.textContent = window.customerDefaultPincode;
        getLocationDetails();
      }
    }
  }
});

function closeZipPopup() {
  const popup = document.querySelector('.zip-code-input-popup');
  if (!popup) return;

  popup.classList.remove('active');
  document.documentElement.classList.remove('location-popup-active');
}

function closeSizePopup () {
  const body = document.body;
  if (body.classList.contains('sticky-variable-buy-open')) {
    body.classList.remove('sticky-variable-buy-open');
  }
  if (body.classList.contains('variable-popup-open')) {
    body.classList.remove('variable-popup-open');
  }
  if (productForm && productForm.classList.contains('sticky-variable')) {
    productForm.classList.remove('sticky-variable');
  }
}


// show lowest price on the product page
(function() {
  const v = window.lowestPriceVariant;
  if (!v) return;
  
  const fmt = p => '₹' + (p/100).toLocaleString('en-IN', {maximumFractionDigits: 0});
  const pct = v.compare_at_price > v.price ? Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) : 0;
  const isOnSale = v.compare_at_price && v.compare_at_price > v.price;
  const discountLabel = window.getVariantDiscountLabel ? window.getVariantDiscountLabel(v) : '';
  
  function update() {
    // Main prices
    const reg = document.querySelector('.price__regular .price-item--regular');
    if (reg) reg.innerHTML = '<span class="price-mrp">MRP</span> ' + fmt(v.price);
    
    const sale = document.querySelector('.price__sale .price-item--sale');
    if (sale) sale.textContent = fmt(v.price);
    
    const comp = document.querySelector('.price__sale s.price-item--regular');
    if (comp) comp.innerHTML = 'MRP ' + fmt(v.compare_at_price);
    
    // Discount (% OFF by default; amount OFF when variant metafield is true)
    if (window.getVariantDiscountFlag && window.getVariantDiscountFlag(v) != null && discountLabel) {
      document.querySelectorAll('.Product_price_save_new').forEach(el => {
        const savingEl = el.querySelector('.data-saving-pdp');
        const labelEl = el.querySelector('.Product_price_save_label');
        if (savingEl) savingEl.setAttribute('data-saving', discountLabel);
        if (labelEl) {
          labelEl.textContent = discountLabel;
        } else {
          el.textContent = discountLabel;
        }
      });
      document.querySelectorAll('.discount_percentage').forEach(el => {
        el.textContent = window.getVariantDiscountLabel(v, { offCasing: 'Off' });
      });
    }
    
    // Sticky & button prices
    document.querySelectorAll('[js-pdp-original-price], .regular_price .price').forEach(el => {
      el.textContent = fmt(v.price);
    });
    
    // Compare prices
    document.querySelectorAll('[js-pdp-sticky-compare-at-price]').forEach(el => {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        el.textContent = fmt(v.compare_at_price);
      } else {
        el.textContent = '';
      }
    });
    
    // Toggle price--on-sale class
    const priceMainNew = document.querySelector('.Product_price_main_new');
    if (priceMainNew) {
      if (isOnSale) {
        priceMainNew.classList.add('price--on-sale');
      } else {
        priceMainNew.classList.remove('price--on-sale');
      }
    }
    
    // Click Standard Size label if lowest price variant is Standard Size
    setTimeout(() => {
      if (v.option1 === 'Standard Size') {
        const input1 = document.querySelector(`[name="Size Options"][value="${v.option1}"]`);
        if (input1) {
          const label1 = document.querySelector(`label[for="${input1.id}"]`);
          if (label1) {
            label1.click();
          }
        }
        
        // Also click the Size label (e.g., "S")
        const input2 = document.querySelector(`[name="Size"][value="${v.option2}"]`);
        if (input2) {
          const label2 = document.querySelector(`label[for="${input2.id}"]`);
          if (label2) {
            label2.click();
          }
        }
      }
    },500)
  }
  
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', update) : update();
})();